import { fetchApi } from "./fetchApi";
const getOPtionalArguments = (options) => {
  const optionalArguments = {};
  Object.keys(options).forEach((key) => {
    if (options) {
      optionalArguments[key] = options[key];
    }
  });
  return optionalArguments;
};
export async function create({
  payload = {},
  context,
  company_id,
  model = "crm.lead",
  options = {
    default_type: false,
  },
}) {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [
        {
          ...payload,
        },
      ],
      model: model,
      method: "create",
      kwargs: {
        context: {
          lang: context.lang,
          tz: context.tz,
          uid: context.uid,
          allowed_company_ids: [company_id],
          params: {
            cids: company_id,
            id: "",
            model: model,
            view_type: "form",
          },
          ...getOPtionalArguments(options),
          search_default_assigned_to_me: 1,
        },
      },
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };
  return fetchApi({
    requestOptions,
    endpoint: `/web/dataset/call_kw/${model}/create`,
  });
}
